import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appClientLogo]'
})
export class ClientLogoDirective implements AfterViewInit {

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'src', environment.clientLogo);
  }

}
